module.exports = __webpack_public_path__ + "img/立即领取.d9f36e15.png";